import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";

import {PromptStartNewOrder} from "../prompt-start-new-order/prompt-start-new-order";

export const PrepareStep = ({item, isCCTemplate, isKit, isPickPack, next: rootNext}) => cs(
    consumeContext("apis"),
    consumeContext("userLevels"),
    ["promptStartNewOrder", ({}, next) => PromptStartNewOrder({next})],

    ({promptStartNewOrder, apis, userLevels}) => rootNext(async ({user}) => {

        const existingOrderSessionInfo = await apis.next.session.getExistingOrderSessionInfo();
        const clearExistingLegacyOrder = async () => {
            if (existingOrderSessionInfo?.orderID) {
                await apis.next.session.clearSessionOrder();
                userLevels.reload();
            }
        };

        if (!item) {

            const startNewOrder = await (async () => {

                if ( isCCTemplate || isPickPack || isKit) {
                    await clearExistingLegacyOrder();
                    return true;
                } else if (
                    // "My Listings" flow
                    (sessionStorage.getItem('listingId') && existingOrderSessionInfo.listingMatches) ||
                    existingOrderSessionInfo?.orderID
                ) {
                    let startNewOrder = true;
                    if(existingOrderSessionInfo.orderStatus !== 'pending approval')
                    {
                        startNewOrder = await promptStartNewOrder({existingOrderSessionInfo});
                    }

                    if (startNewOrder) {
                        await apis.next.session.clearSessionOrder();
                        return true;
                    } else {
                        return false;
                    }
                } else {
                    return true;
                }
            })();

            if (startNewOrder) {
                return {
                    type: "createNew",
                    listingUniqueId: sessionStorage.getItem('listingUniqueId'),
                };
            } else {
                return {
                    type: "update",
                    oldItem: await apis.next.item.getItem(existingOrderSessionInfo.orderID),
                };
            }
        } else { // item != null

            if (isPickPack) {
                await clearExistingLegacyOrder();
                return {
                    type: "update",
                    oldItem: item,
                };
            } else if(isCCTemplate || isKit) {
                await clearExistingLegacyOrder();
                if (!(item.idAgent === user.agentId || (item.idAgent === "Branch Order" && user.branchId === item.idBranch))) {
                    return {
                        type: "createNew",
                        listingUniqueId: undefined,
                    };
                } else {
                    return {
                        type: "update",
                        oldItem: item,
                    };
                }
            } else if (!(item.idAgent === user.agentId || (item.idAgent === "Branch Order" && user.branchId === item.idBranch))) {
                return {
                    type: "updateForceAgent",
                    oldItem: item,
                    reset: user.branchId !== item.idBranch ? "branch" : "agent",
                };
            } else {
                return {
                    type: "update",
                    oldItem: item,
                };
            }
        }
    }),
);
